/** The season Resources fixture (OEP-TEST and AGU26 start from it; tools/stage-persona and tools/oep-roster both read it). */
import { OEP_OFFICE_HOURS_KIND, type IOEPResource, type IOEPRoleResources } from './resources.js';

const AGU = 'https://www.agu.org/';
const res = (Kind: string, Title: string, Note: string, Url: string = AGU): IOEPResource => ({ Kind, Title, Note, Url });

/**
 * Season.Resources: the prototype RESOURCES (logic.js:115-137) with every Url set to agu.org, plus
 * the nominator office-hours tile the Nominate view renders (markup.html:678-681; Kind
 * OEP_OFFICE_HOURS_KIND, empty Note so the view fills it from Timeline.OfficeHours — T27).
 */
export const SAMPLE_RESOURCES: IOEPRoleResources = {
  presenter: [
    res('PDF', 'How does the awards process work?', 'What nominators will be looking for.'),
    res('PDF', 'Presenting at AGU26', 'Poster, Oral, and GeoBurst logistics and guidelines.', 'https://www.agu.org/annual-meeting/present?tab=presenter-resources'),
    res('PDF', 'How do I get feedback on my draft presentation?', 'Timing, draft upload, and more.'),
  ],
  reviewer: [
    res('PDF', 'Reviewer guidance and rubric', 'The five areas, with the full rubric wording.'),
    res('PDF', 'Giving feedback that encourages', 'Two pages. Worth reading before your first review.'),
  ],
  nominator: [
    res('PDF', 'Nomination guidance', 'Why less is more, and what committees need from you.'),
    res(OEP_OFFICE_HOURS_KIND, 'Nominator office hours', ''),
    res('1 pg', 'Conflict of interest, plainly', 'When to hand a nomination to a coconvener.'),
  ],
  committee: [
    res('PDF', 'Section committee handbook', 'How to weigh nominations against draft round feedback.'),
    res('PDF', 'Award criteria and quotas', 'Winner limits and eligibility for AGU26.'),
  ],
  staff: [
    res('Sheet', 'Season run of show', 'Every date, owner, and platform for AGU26.'),
    res('PDF', 'Reminder copy library', 'Approved wording for each nudge.'),
  ],
};
